module.exports = __webpack_public_path__ + "static/ColdbrewBottleFrontVid-a02c783ba87ec03f979ebd391a650604.mp4";